import { useRouteMatch } from 'react-router-dom';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PLAN_TEMPLATES_KEY } from './useLinkedPlanTemplates.query';

const useUnlinkTemplateQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { params } = useRouteMatch<{ id: string }>();

  const { mutateAsync, isLoading } = useMutation(
    (id: string) =>
      api.patch(API_URL.TEMPLATES_UNLINKING_BY_PLAN_ID(id), undefined, {
        params: {
          organization_id: params.id,
        },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [PLAN_TEMPLATES_KEY],
        });
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    handleDelete: mutateAsync,
    isLoading,
  };
};

export default useUnlinkTemplateQuery;
